import endpoint from '../../app_configuration/apiEndpoints/cmsEndpoints';

const getBranchDashBoardData = async (data) => {
    const url = `${process.env.REACT_APP_PUBLIC_ECOMM_URL}${endpoint.getBranchDashBoardData()}`;

    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    });

    if (!res.ok) {
        return { error: true, message: 'Get branch dashboard data request failed', status: res.status, data: [] };
    }
    const getData = await res.json();
    return { status: res.status, data: getData };
};

export default getBranchDashBoardData;
